import { Component, Input, OnInit } from '@angular/core';
import { FilterFormValue, TaskFilterService } from '../task-filter-utility.service';
import * as moment from 'moment';

@Component({
  selector: 'kt-task-action-button',
  templateUrl: './task-action-button.component.html',
  styleUrls: ['./task-action-button.component.scss'],
})
export class TaskActionButtonComponent implements OnInit {
  priorityOptions = [
    { value: '', label: 'All Priority' },
    { value: 'HIGH', label: 'High Priority' },
    { value: 'MEDIUM', label: 'Medium Priority' },
    { value: 'LOW', label: 'Low Priority' },
  ];
  @Input() progressOption;
  filters: FilterFormValue = {
    withFollowUp: false,
    dueDate: { fromDateDue: null, toDateDue: null },
    createdDate: { fromDateCreated: null, toDateCreated: null },
    user: null,
    entity: null,
    team: [],
    template: null,
    tag: null,
    priority: '',
    status: '',
    office: null,
  };

  constructor(private taskFilterService: TaskFilterService) {}
  activeFilter;

  ngOnInit(): void {
    this.taskFilterService.activeFilter.subscribe((val) => {
      this.activeFilter = val;
    });
  }

  onActionClick(priorityOption: string) {
    if (this.progressOption.value === 'OVERDUE') {
      this.filters.dueDate.toDateDue = moment().subtract(1, 'days').toDate();
    } else {
      this.filters.dueDate.toDateDue = this.taskFilterService.initialFormValue.dueDate.toDateDue;
      this.filters.status = this.progressOption.value;
    }
    this.filters.priority = priorityOption;
    this.taskFilterService.updateFilterObject(this.filters);
    this.taskFilterService.activeFilter.next(this.progressOption);
    this.taskFilterService.isDefaultFilteredValue.next(false);
  }
}
